import { login, logout } from '@/apis/auth'
import { getUserInfo } from '@/apis/token'
import { getToken, setToken, removeToken } from '@/utils/auth'
import asyncRouters from '@/router/asyncRouters'

const state = {
    id: '',
    token: getToken(),
    name: '',
    email: '',
    navigations: [],
    entities: [],
    role: {},
}

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_ID: (state, id) => {
        state.id = id
    },
    SET_NAME: (state, name) => {
        state.name = name
    },
    SET_EMAIL: (state, email) => {
        state.email = email
    },
    SET_NAVIGATIONS: (state, navigations) => {
        state.navigations = navigations
    },
    SET_ENTITYS: (state, entities) => {
        state.entities = entities
    },
    SET_ROLE: (state, role) => {
        state.role = role
    }
}

const actions = {
    // user login
    login({ commit }, userInfo) {
        return new Promise((resolve, reject) => {
            login(userInfo).then(response => {
                const { data } = response
                commit('SET_TOKEN', data.access_token)
                setToken(data.access_token)
                resolve(response)
            }).catch(error => { 
                if(error.code == 12131017) {
                    const { data } = error
                    commit('SET_TOKEN', data.access_token)
                    setToken(data.access_token)
                }
                reject(error)
            })
        })
    },

    // get user info
    getUserInfo({ commit }) {
        return new Promise((resolve, reject) => {
            getUserInfo().then(response => {
                const { data } = response
                const { id, first_name, last_name, email } = data.user
                const { navigations, entities, role } = data.authorization
                
                commit('SET_ID', id)
                commit('SET_NAME', first_name + ' ' + last_name)
                commit('SET_EMAIL', email)
                // commit('SET_NAVIGATIONS', navigations.filter(el => el.is_visible == 1))
                commit('SET_NAVIGATIONS', navigations)
                commit('SET_ENTITYS', entities)
                commit('SET_ROLE', role)

                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },

    // user logout
    logout({ commit }) {
        return new Promise((resolve, reject) => {
            logout().then(() => {
                commit('SET_TOKEN', '')
                commit('SET_ID', '')
                commit('SET_EMAIL', '')
                commit('SET_NAME', '')
                commit('SET_ENTITYS', [])
                commit('SET_ROLE', {})
                setTimeout(() => {
                    commit('SET_NAVIGATIONS', [])
                }, 1000)
                removeToken()
                localStorage.clear()
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },

    // remove token
    resetToken({ commit }) {
        return new Promise(resolve => {
            commit('SET_TOKEN', '')
            commit('SET_ID', '')
            commit('SET_EMAIL', '')
            commit('SET_NAME', '')
            commit('SET_NAVIGATIONS', [])
            commit('SET_ENTITYS', [])
            commit('SET_ROLE', {})
            removeToken()
            localStorage.clear()
            resolve()
        })
    },

    generateRoutes({state}) {
        return new Promise(resolve => {
            const reportNavigations = state.navigations.filter(el => el.code.startsWith('report_'))
            const names = state.navigations.map(el => el.code);
            if(reportNavigations.length > 0) {
                names.push('report')

                const reportIndex = asyncRouters.findIndex(el => el.path == '/report')
                const reportRouterChildren = asyncRouters[reportIndex]['children']
                const reportUrls = reportNavigations.map(el => el.url)
                const allowReportRouterChildren = reportRouterChildren.filter(el => el.path == '' || reportUrls.indexOf('/report/' + el.path) > -1)
                asyncRouters[reportIndex]['children'] = allowReportRouterChildren
            }
            const accessRouters = asyncRouters.filter(item => names.indexOf(item.meta.code) > -1 )
            resolve(accessRouters)
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}